(function() {

  if (location.hash) {
    // fix scroll position on page load
    setTimeout(function() {
      window.scrollTo(0, 0);

      const name = location.hash.replace(/^#/, '');
      const anchor = document.querySelector(`.u-anchor[name="${name}"]`);

      const nextElement = anchor.nextElementSibling || anchor.parentElement.nextElementSibling;
  
      gsap.to(window, {duration: .1, scrollTo: {
        y: anchor, 
        offsetY: document.querySelector('.u-header').offsetHeight + 20 - parseInt(window.getComputedStyle(nextElement).paddingTop)
      }});
    }, 1);
  }

  document.addEventListener('generate-smooth-scroll-links', function (e) {
    console.log('generate-smooth-scroll-links');
    e.detail.querySelectorAll(`a[href^="#"],a[href^="${window.location.pathname}#"]`).forEach(link => {

      if(link.classList.contains('u-link--posibile-on-page')) return;

      link.classList.add('u-link--posibile-on-page');
      link.addEventListener('click', function (e) {

        const name = this.getAttribute('href').split('#')[1];
        const anchor = document.querySelector(`.u-anchor[name="${name}"]`);

        if(anchor) {
          e.preventDefault();
          // anchor.scrollIntoView({
          //   behavior: 'smooth'
          // });

          var event = new CustomEvent('close-header');
          document.dispatchEvent(event);

          const nextElement = anchor.nextElementSibling || anchor;

          // parallax fix
          const parallaxWrapper = nextElement.closest('.u-parallax--fixed');
          if(parallaxWrapper) {
            parallaxWrapper.classList.remove('u-parallax--fixed');
          }

          gsap.to(window, {duration: 1, scrollTo: {
            y: anchor, 
            offsetY: document.querySelector('.u-header').offsetHeight - parseInt(window.getComputedStyle(nextElement).paddingTop)
          }});
        }
      });
    });
  });

})();